import { render, staticRenderFns } from "./videoAccountActivitiesAddAndEdit.vue?vue&type=template&id=4128546e&scoped=true"
import script from "./videoAccountActivitiesAddAndEdit.vue?vue&type=script&lang=js"
export * from "./videoAccountActivitiesAddAndEdit.vue?vue&type=script&lang=js"
import style0 from "./videoAccountActivitiesAddAndEdit.vue?vue&type=style&index=0&id=4128546e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4128546e",
  null
  
)

export default component.exports